import { createAction, handleActions } from "redux-actions";

import { List, Map, fromJS } from "immutable";
import { pender } from "redux-pender";

import * as eduLib from "libs/eduLib";
import * as normalizer from "libs/normalizer";

// action types
const INITIAL_STORE = "eduTemplate/INITIAL_STORE";
const CHANGE_PARAM = "eduTemplate/CHANGE_PARAM";
const GET_EDU_TEMPLATE = "eduTemplate/GET_EDU_TEMPLATE";
const ADD_EDU_TEMPLATE = "eduTemplate/ADD_EDU_TEMPLATE";
const DELETE_EDU_TEMPLATE = "eduTemplate/DELETE_EDU_TEMPLATE";

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeParam = createAction(CHANGE_PARAM);
export const getEduTemplate = createAction(GET_EDU_TEMPLATE, eduLib.getEduTemplateAPI);
export const addEduTemplate = createAction(ADD_EDU_TEMPLATE, eduLib.addEduTemplateAPI);
export const deleteEduTemplate = createAction(DELETE_EDU_TEMPLATE, eduLib.deleteEduTemplateAPI);

// initial state
const initialState = fromJS({
  data: {
    result: -1,
    success: [],
    fail: [],
  },
  indexByNo: {},
  needReload: false,
  page: 1,
  totalPages: 0,
  totalCount: 0,
  param: Map({
    filter: Map({}),
    sort: [{ field: "eduAttachNo", order: "DESC" }],
    offset: 0,
    limit: 50,
  }),
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(["param", name], value);
    },

    // 교육 템플릿 리스트 조회
    ...pender({
      type: GET_EDU_TEMPLATE,
      onSuccess: (state, action) => {
        const { data } = action.payload;
        const { offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = data.list.length > 0 ? data.list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);
        const stateObj = normalizer.payloadDataSaver(state, "data", data);
        return stateObj.set("needReload", false).set("totalPages", totalPages).set("totalCount", totalCount);
      },
      onFailure: (state, action) => {
        console.log("GET_EDU_TEMPLATE 실패");
      },
    }),

    // 교육 템플릿 등록
    ...pender({
      type: ADD_EDU_TEMPLATE,
      onSuccess: (state, action) => {
        return state.set("needReload", true);
      },
      onFailure: (state, action) => {
        console.log("ADD_EDU_TEMPLATE 실패");
      },
    }),

    // 교육 템플릿 삭제
    ...pender({
      type: DELETE_EDU_TEMPLATE,
      onSuccess: (state, action) => {
        return state.set("needReload", true);
      },
      onFailure: (state, action) => {
        console.log("DELETE_EDU_TEMPLATE 실패");
      },
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/eduTemplate.js